<template>
<div class="extensions-slot-component">
  <component v-for="component in components" :key="component.id" :is="component.component" v-bind="component.attributes"/>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import get from 'lodash/get'

if (typeof window.Vue === 'undefined') {
  window.Vue = Vue
}

export default Vue.extend({
  computed: {
    ...mapGetters({
      extensions: 'extensions/extensions',
    }),
  },

  created() {
    this.preloadExtensions()
  },

  methods: {
    preloadExtensions() {
      if (this.extensionsAreLoading) {
        return
      } else if (!this.extensions.length) {
        return
      }

      const totalCount = this.extensions.length
      let loadedCount = 0

      this.extensionsAreLoading = true

      const body = document.getElementsByTagName('body')[0]

      this.extensions.forEach(extension => {
        if (!extension || !extension.url || !extension.component) {
          return
        }

        const script = document.createElement('script')
        script.src = extension.url
        script.onload = () => {
          this.extensionLoaded(extension)
          ++loadedCount

          if (loadedCount === totalCount) {
            this.extensionsAreLoading = false
          }
        }

        script.onerror = () => {
          ++loadedCount

          if (loadedCount === totalCount) {
            this.extensionsAreLoading = false
          }
        }

        body.appendChild(script)
      })
    },

    extensionLoaded(extension) {
      console.log(`Extension loaded`, extension)

      const component = get(extension, 'component')

      if (!component) {
        return
      }

      let attributes = get(extension, 'settings', {})

      if (typeof attributes !== 'object') {
        attributes = {}
      }

      this.components.push({
        id: `extension-component-${Math.random().toString().replace('.', '_')}`,
        component,
        attributes,
      })
    },
  },

  data() {
    return {
      extensionsAreLoading: false,
      components: [],
    }
  }
})
</script>
